import React from 'react';
import { useObserver } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import './SocialLinkCreatorBanner.scss';
import { useModuleStore } from '../../../enrollment-process/module-management/model/ModuleStoreHook';
import { useRootStore } from '../../../root/RootStoreHooks';

export const SocialLinkCreatorBanner = () => {
  const enrollmentKitStore = useModuleStore('enrollmentKitSelection');
   const rootStore = useRootStore();
   const store=rootStore.moduleStores.socialLinkCreatorEntry!;
  enrollmentKitStore.updateRequireStarterKit(false);
  const { t } = useTranslation();

  return useObserver(() => {
    return (
      <div className="navbar social-link-creator-banner">
        <div>
        {t(
        store?.isEdit
        ? 'SocialLinkCreatorBanner_Modify'
        : 'SocialLinkCreatorBanner_SocialLinkCreatorModeEnabled'
       )}
        </div>
      </div>
    );
  });
};
